class LqdCounterHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initCounter();

  }

  getDefaultSettings() {
    return {
      selectors: {
        counterElement: '[data-enable-counter]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $counterElement: this.$element.find(selectors.counterElement),
    }
  }

  initCounter() {

    this.elements.$counterElement.liquidCounter();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCounterHandler, { $element } );
};